export const MERGE_CART= 'MERGE_CART'
export const MERGE_CART_SUCCESS= 'MERGE_CART_SUCCESS'
export const MERGE_CART_ERROR='MERGE_CART_ERROR'

export const MergeCart= (data) => ({
    type: MERGE_CART,
    payload: data
})